import { gql } from '@apollo/client';

export const GET_DOCUMENT_LINKS_BY_LOCATION = gql`
  query FindAllByLocation($uuid: ID!) {
    findAllByLocation(uuid: $uuid) {
      link
      name
      uuid
    }
  }
`;

export const GET_DOCUMENT_LINKS_BY_STRATEGY = gql`
  query FindAllByStrategyFacility($uuid: ID!) {
    findAllByStrategyFacility(uuid: $uuid) {
      link
      name
      uuid
    }
  }
`;

export const GET_DOCUMENT_LINKS_BY_PRODUCTION = gql`
  query FindAllByStrategyProductionEquipment($uuid: ID!) {
    findAllByStrategyProductionEquipment(uuid: $uuid) {
      link
      name
      uuid
    }
  }
`;

export const GET_DOCUMENT_LINKS_BY_PEOPLE = gql`
  query FindAllByStrategyPeople($uuid: ID!) {
    findAllByStrategyPeople(uuid: $uuid) {
      link
      name
      uuid
    }
  }
`;

export const GET_DOCUMENT_LINKS_BY_IT_RESOURCES = gql`
  query FindAllByITResource($uuid: ID!) {
    findAllByITResource(uuid: $uuid) {
      link
      name
      uuid
    }
  }
`;

export const GET_DOCUMENT_LINKS_BY_SUPPLY_CHAIN = gql`
  query FindAllBySupplyChain($uuid: ID!) {
    findAllBySupplyChain(uuid: $uuid) {
      link
      name
      uuid
    }
  }
`;

export const CREATE_DOCUMENT_LINK = gql`
  mutation CreateDocumentLink($data: CreateDocumentLinkInput!) {
    createDocumentLink(data: $data) {
      link
      name
      uuid
    }
  }
`;

export const UPDATE_DOCUMENT_LINK = gql`
  mutation UpdateDocumentLink($data: UpdateDocumentLinkInput!) {
    updateDocumentLink(data: $data) {
      link
      name
      uuid
    }
  }
`;

export const DELETE_DOCUMENT_LINK = gql`
  mutation DeleteDocumentLink($uuid: ID!) {
    deleteDocumentLink(uuid: $uuid) {
      link
      name
      uuid
    }
  }
`;
